import { render } from "./PressCardEditor.vue?vue&type=template&id=08333bad&scoped=true"
import script from "./PressCardEditor.vue?vue&type=script&lang=js"
export * from "./PressCardEditor.vue?vue&type=script&lang=js"

import "./PressCardEditor.vue?vue&type=style&index=0&id=08333bad&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08333bad"]])

export default __exports__